import { type SvgIconProps } from '@common/components/svgs/props';

function IconBurgerMenu(
  { size = 24, color = 'scheme-feedback-text-color', ...rest }: Readonly<SvgIconProps>,
) {
  return (
    <svg
      {...rest}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="svg-BurgerMenu"
    >
      <path d="M21 8L3 8V6H21V8Z" fill={`var(--${color})`} />
      <path d="M21 13L3 13V11L21 11V13Z" fill={`var(--${color})`} />
      <path d="M3 18L21 18V16L3 16V18Z" fill={`var(--${color})`} />
    </svg>
  );
}

IconBurgerMenu.displayName = 'BurgerMenu';

export default IconBurgerMenu;
